import { Theme } from '@mui/material/styles'

export default function Menu(_: Theme) {
  return {
    MuiMenuItem: {},
  }
}
